import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import { SCUIContent } from '../../../../atomic/organisms';
import { SCUIButton, SCUILoadingLinear } from '../../../../atomic/atoms';
import { SCUIBreadCrumb } from '../../../../atomic/molecules';
import { ScheduleCreate, ScheduleDetail, ScheduleList } from '../index';

import { useScheduleService } from '../../context/ScheduleServiceContext';
import { SW } from './scheduleWrapper.classes';

export const ScheduleWrapper = () => {
    const { isLoading, selectedJob, isEditing, setIsCreating, isCreating } = useScheduleService();

    const { t } = useTranslation();

    return (
        <SCUIContent className={SW.page}>
            <>
                {isLoading && (
                    <Grid
                        className={SW.loadingRow}
                        sx={{ marginBottom: '24px' }}
                        size={{
                            xl: 12,
                            md: 12,
                            lg: 12,
                            xs: 12
                        }}>
                        <div className={SW.loadingSection}>
                            <SCUILoadingLinear display={isLoading} />
                        </div>
                    </Grid>
                )}
                {isEditing || isCreating ? (
                    <div className={SW.createSection}>
                        <ScheduleCreate />
                    </div>
                ) : selectedJob?.id ? (
                    <div className={SW.detailSection}>
                        <ScheduleDetail />
                    </div>
                ) : (
                    <>
                        <Grid className={SW.listHeaderRow} container direction="row" spacing={2}>
                            <div className={SW.listBreadcrumb}>
                                <SCUIBreadCrumb
                                    onlyTitle={t('scheduleService.header')}
                                    componentLink={'/schedule-service'}
                                />
                            </div>
                            <SCUIButton
                                className={SW.addButton}
                                text={t('general.add')}
                                type="primary"
                                sizeType="fixed"
                                size={'m'}
                                onClick={() => setIsCreating(true)}
                                style={{ marginLeft: 'auto' }}
                            />
                        </Grid>
                        <div className={SW.listSection}>
                            <ScheduleList />
                        </div>
                    </>
                )}
            </>
        </SCUIContent>
    );
};
